import React from 'react';
import { motion } from 'framer-motion';

const Specials = () => {
  const specialOffers = [
    {
      id: 1,
      title: 'Happy Hour Marino',
      description: 'Disfruta de 2x1 en cócteles de marisco y tapas de pescado fresco todos los días de 17:00 a 19:00 hrs.',
      icon: 'cocktail',
      days: 'Lunes a Viernes',
      discount: '2x1'
    },
    {
      id: 2,
      title: 'Parrillada Familiar',
      description: 'Parrillada de mariscos para 4 personas con una botella de vino blanco de cortesía.',
      icon: 'utensils',
      days: 'Sábados y Domingos',
      discount: '15% OFF'
    },
    {
      id: 3,
      title: 'Martes de Ceviche',
      description: 'Todos los martes disfruta de nuestra selección especial de ceviches a un precio único.',
      icon: 'fish',
      days: 'Martes',
      discount: '20% OFF'
    },
  ];

  const upcomingEvents = [
    {
      id: 1,
      title: 'Noche de Música en Vivo',
      date: 'Viernes 21 de Abril, 20:00 hrs',
      description: 'Disfruta de nuestra selección de platos mientras te envuelven ritmos latinos y música del mar.'
    },
    {
      id: 2,
      title: 'Master Class de Cócteles Marinos',
      date: 'Sábado 29 de Abril, 17:00 hrs',
      description: 'Aprende a preparar deliciosos cócteles con productos del mar de la mano de nuestro bartender jefe.'
    },
  ];

  return (
    <section id="specials" className="py-20 bg-white">
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="section-title inline-block">Especiales y Eventos</h2>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            Descubre nuestras promociones especiales y próximos eventos para disfrutar aún más de la experiencia La Barra Brava.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Special Offers Section */}
          <div>
            <h3 className="text-2xl font-bold text-marina-700 mb-6">Promociones Especiales</h3>
            <div className="space-y-6">
              {specialOffers.map((offer, index) => (
                <motion.div
                  key={offer.id}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="card p-6 relative overflow-hidden"
                >
                  <div className="absolute -right-4 -top-4 bg-coral-500 text-white w-20 h-20 rotate-12 flex items-center justify-center">
                    <span className="text-lg font-bold rotate-[-12deg]">{offer.discount}</span>
                  </div>
                  <div className="flex items-start">
                    <div className="mr-4 text-marina-600 text-2xl">
                      <i className={`fas fa-${offer.icon}`}></i>
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-marina-800 mb-2">{offer.title}</h4>
                      <p className="text-gray-600 mb-2">{offer.description}</p>
                      <div className="text-sm font-medium text-marina-600">
                        <i className="far fa-calendar-alt mr-2"></i>
                        {offer.days}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>

          {/* Upcoming Events Section */}
          <div>
            <h3 className="text-2xl font-bold text-marina-700 mb-6">Próximos Eventos</h3>
            <div className="relative">
              {/* Background decoration */}
              <div className="absolute top-0 bottom-0 left-8 w-0.5 bg-marina-100"></div>
              
              <div className="space-y-8">
                {upcomingEvents.map((event, index) => (
                  <motion.div
                    key={event.id}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="relative pl-12"
                  >
                    <div className="absolute left-0 top-0 w-16 h-16 flex items-center justify-center">
                      <div className="w-6 h-6 rounded-full bg-marina-500 border-4 border-white z-10"></div>
                    </div>
                    <div className="card p-6">
                      <h4 className="text-xl font-bold text-marina-800 mb-2">{event.title}</h4>
                      <div className="text-sm font-medium text-marina-600 mb-3">
                        <i className="far fa-calendar-check mr-2"></i>
                        {event.date}
                      </div>
                      <p className="text-gray-600">{event.description}</p>
                      <button className="mt-4 inline-flex items-center text-sm font-medium text-marina-600 hover:text-marina-800 transition-colors duration-300">
                        Reservar lugar
                        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 8l4 4m0 0l-4 4m4-4H3"></path>
                        </svg>
                      </button>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          viewport={{ once: true }}
          className="mt-16 text-center"
        >
          <div className="py-6 px-8 bg-marina-50 rounded-xl inline-block max-w-2xl">
            <h3 className="text-xl font-bold text-marina-800 mb-2">¿Tienes una celebración especial?</h3>
            <p className="text-gray-600 mb-4">Contáctanos para crear un menú personalizado para tu evento o reservar un espacio privado.</p>
            <button className="btn-secondary">
              Consultar por Eventos
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Specials;
